import React from 'react';
import tw from 'twin.macro';
import styled from '@emotion/styled';

export interface Props {
  id?: string;
  htmlFor?: string;
  className?: string;
  children: React.ReactNode;
}

export const labelDesign = tw`block text-sm text-neutral-moderate`;

const LabelStyled = styled.label`
  ${labelDesign}
`;

export default function Label(props: Props) {
  const { children, id, htmlFor, className } = props;
  return (
    // eslint-disable-next-line jsx-a11y/label-has-for
    <LabelStyled
      htmlFor={htmlFor || id}
      id={htmlFor ? id : undefined}
      className={className}
    >
      {children}
    </LabelStyled>
  );
}
